import { Route } from 'vue-router';
import { ProcessType } from '@/Domain/enum';

// Nombres de las rutas de proceso que llevan el parámetro `:type` (new/:type y :id/edit/:type).
const processRouteNames: string[] = [
  ...Object.values(ProcessType.routeNew as Record<number, string>),
  ...Object.values(ProcessType.routeEdit as Record<number, string>)
];

/**
 * CON-1270: al entrar por URL, `to.params.type` llega como string ('0', '1', '2').
 * Lo normaliza a número en las rutas de proceso para que el resto de la app
 * (comparaciones estrictas contra ProcessType.enum) funcione igual que al navegar
 * desde la aplicación. Síncrono e idempotente: solo convierte strings puramente numéricos.
 */
export function normalizeProcessType(to: Route): void {
  const type = to.params ? to.params.type : undefined;
  if (typeof type !== 'string' || !/^\d+$/.test(type)) {
    return;
  }
  if (!to.name || !processRouteNames.includes(to.name)) {
    return;
  }
  to.params.type = Number(type) as any;
}
